import { getFieldInputStylesAsClassName } from '../field-styles';
import { twMerge } from 'tailwind-merge';

export const getFieldTextareaStylesAsClassName = (
  isInvalid: boolean,
  showLabel: boolean,
  disabled: boolean,
  readOnly: boolean
): string => {
  return twMerge(
    getFieldInputStylesAsClassName(isInvalid, showLabel, disabled, readOnly),
    'min-h-[46px]'
  );
};
